import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import Modal from "react-bootstrap/Modal";
import { Row, Col } from "react-bootstrap";
import uploadService from "../../services/uploadfile.service";
import apihostname from "../../services/apihostname";

//Import Loading
import LoadingAlert from "../../components/LoadingAlert";
import { toast } from "react-toastify";

function FormUpload(props) {
  const [files, setFiles] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);
  const [previewImage, setPreviewImage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [filename, setFilename] = useState("filename.jpg");
  const ref = useRef();
  const [showDownloadScan, setShowDownScan] = useState(false);

  const listfile = (master_id) => {
    setLoading(true);
    uploadService
      .listMasterfile(master_id)
      .then((response) => {
        setFiles(response.data.data);
      })
      .catch((err) => toast.error(err))
      .finally(() => {
        setLoading(false);
      });
  };
  useEffect(() => {
    listfile(props.master_id);
  }, [props.master_id]);

  useEffect(() => {
    var wsImpl = window.WebSocket || window.MozWebSocket;

    window.ws = new wsImpl("ws://localhost:8181/");
    window.ws.onmessage = function (e) {
      if (typeof e.data === "string") {
        //IF Received Data is String
      } else if (e.data instanceof ArrayBuffer) {
        //IF Received Data is ArrayBuffer
      } else if (e.data instanceof Blob) {
        var f = e.data;

        var reader = new FileReader();

        reader.onload = async function (e) {
          setLoading(true);
          const blob = await fetch(e.target.result).then((res) => res.blob());
          setSelectedFile(blob);
          setPreviewImage(URL.createObjectURL(blob));
          setLoading(false);
        };
        reader.readAsDataURL(f);
      }
    };
    window.ws.onopen = function () {
      //Do whatever u want when connected succesfully
    };
    window.ws.onclose = function () {
      setShowDownScan(true);
    };
  }, []);

  const handleClose = () => {
    props.hidden_func(false);
    setPreviewImage(null);
    setSelectedFile(null);
    setFilename("filename.jpg");
  };

  const scanImage = () => {
    window.ws.send("1100");
  };
  const changeFileName = (e) => {
    setFilename(e.target.value);
  };

  const handleAdd = (e) => {
    e.preventDefault();
    const data = new FormData();
    const fileSizeKiloBytes = selectedFile.size / 1024;
    if (fileSizeKiloBytes > 15 * 1024) {
      return toast.error("ไม่สามารถอัพโหลดไฟล์มากกว่า 15 MB ได้");
    }
    data.append("singlefileUpload", selectedFile, filename);
    data.append("master_id", props.master_id);
    setLoading(true);
    uploadService
      .uploadMastersinglefile(data)
      .then((response) => {
        setFiles([...files, response.data.data.filename]);
        ref.current.value = "";
        setPreviewImage(null);
        setSelectedFile(null);
        setFilename("filename.jpg");
      })
      .catch((err) => {
        toast.error(err.response.data.message);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  function handleChange(e) {
    e.preventDefault();
    setSelectedFile(e.target.files[0]);
    setFilename(e.target.files[0].name);
  }

  const handleRemoveItem = (filename) => {
    uploadService
      .deleteMastersinglefile({
        filename: filename,
        master_id: props.master_id,
      })
      .then((response) => {
        const newArray = files.filter(function (f) {
          return f !== response.data.data.filename;
        });
        setFiles(newArray);
      });
  };
  return (
    <>
      {loading ? <LoadingAlert /> : ""}
      <div
        className="modal fade dalert"
        role="dialog"
        hidden={showDownloadScan}
      >
        <div className="modal-dialog modal-lg" role="document">
          <div className="modal-content">
            <div className="modal-header">Connection Failed</div>
            <div className="modal-body">
              No Scan app application found in your machine please
              download,install and open first then refresh the browser.
              <a href="~/SrcFile/Scan_App_SetUp.msi" download>
                Download Files
              </a>
            </div>
          </div>
        </div>
      </div>
      <Modal size="lg" show={props.show} onHide={handleClose} animation={false}>
        <Modal.Header closeButton>
          <Modal.Title>อัพโหลดเอกสาร</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {files.map((item) => {
            return (
              <>
                <li>
                  {" "}
                  <a
                    href={
                      apihostname +
                      "/uploads/master/" +
                      props.master_id +
                      "/" +
                      item
                    }
                    download={item}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <button
                      className="btn btn-primary btn-sm"
                      style={{ padding: "0.3rem" }}
                    >
                      download
                    </button>
                  </a>
                  {item}
                  <i
                    className="bi bi-x"
                    onClick={() => handleRemoveItem(item)}
                    style={{ color: "red" }}
                  ></i>
                </li>
              </>
            );
          })}
          <Row>
            {previewImage ? (
              <>
                <Col md={12}>
                  {" "}
                  <img
                    src={previewImage}
                    alt="dummy"
                    width="150"
                    height="150"
                  />
                  <input
                    type="text"
                    name="filename"
                    value={filename}
                    onChange={changeFileName}
                  />
                </Col>
              </>
            ) : (
              <Col md={12}></Col>
            )}
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <input
            type="file"
            ref={ref}
            onChange={handleChange}
            accept=".png,.jpg,.jpeg,.pdf,.img"
          />
          <button className="btn btn-primary" onClick={handleAdd}>
            เพิ่มเอกสาร
          </button>
          <button type="button" onClick={scanImage} className="btn btn-primary">
            สแกนเอกสาร
          </button>
          <button
            type="button"
            onClick={handleClose}
            className="btn btn-primary"
          >
            บันทึก
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default FormUpload;
FormUpload.propTypes = {
  show: PropTypes.bool,
  hidden_func: PropTypes.func,
  master_id: PropTypes.number,
};
